import { PostProperties } from "../types";
import image from "../img/lostGemKevinSaunderson.jpg";

const post: PostProperties = {
  id: 20,
  title: "Kevin Saunderson - Berghain, Berlin (13.12.2008)",
  content: `Kevin is one of the producers who helped shape the sound of techno music in the 1980s. He gained fame as one-third of the Belleville Three before his solo career took off with hits like "Big Fun" and "Good Life." Saunderson founded his own record label, KMS Records, which became a platform for emerging techno artists. Kevin's influence can be heard in the work of countless artists who have followed in his footsteps, cementing his legacy as a pioneer of techno music.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/kevin-saunderson-berghain-berlin-13122008",
  category: "Lost Gem",
  translationsBg: {
    content: `Кевин е един от продуцентите, допринесли за оформянето на звука на техно музиката през 80-те. Той придоби слава като една трета от Belleville Three, преди соловата му кариера да тръгне нагоре с хитове като "Big Fun" и "Good Life". Saunderson основа собствения си лейбъл KMS Records, превърнал се в платформа за начинаещи техно артисти. Влиянието на Кевин може да бъде усетено в творчеството на безброй артисти, стъпили по неговите следи, затвърждавайки наследството му като пионер на техно музиката.`,
  },
};

export default post;
